export const sizeButton = (size: string, selectedSize: string | undefined) => {
  if (size?.startsWith('Euro')) {
    const sizes = size?.replace(/\s+/g, ' ')?.trim();
    const splitIndex = sizes?.indexOf('US');

    const size1 = sizes?.substring(0, splitIndex)?.trim();
    const size2 = sizes?.substring(splitIndex)?.trim();
    return (
      <section className={`flex flex-col ${size === selectedSize ? 'md:min-w-[119px]' : 'md:min-w-[121px]'} py-[1px]`}>
        <div className="font-bold">{size1}</div>
        <div className="font-medium">{size2}</div>
      </section>
    );
  } else {
    return <>{size}</>;
  }
};
